import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConstants } from 'src/app/app.constants';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ErrorHandlerService } from "src/app/core/services/error-handler.service";

@Injectable({
  providedIn: 'root'
})
export class UploadFilesService {

  constructor(private http: HttpClient, private router: Router, private errorHandlerService: ErrorHandlerService) { }

  uploadSalesVolumeFile(formData: any, email: string): Observable<any> {
    const data = { ...formData, user_email: email };
    return this.http.post(`${AppConstants.API_ENDPOINT1}${AppConstants.API.UPLOADEXCEL.UPLOAD_SALES_VOLUME}`, data).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  getGenericNameDropdown(data) {
    return this.http.post(`${AppConstants.API_ENDPOINT1}${AppConstants.API.SALES_AND_VOLUME_APIS.GENERIC_NAME_DROPDOWN}`, data).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  getBrandNameDropdown(data) {
    return this.http.post(`${AppConstants.API_ENDPOINT1}${AppConstants.API.SALES_AND_VOLUME_APIS.BRAND_NAME_DROPDOWN}`, data).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  getRoaDropdown(data) {
    return this.http.post(`${AppConstants.API_ENDPOINT1}${AppConstants.API.SALES_AND_VOLUME_APIS.ROA_DROPDOWN}`, data).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  getDosageDropdown(data) {
    return this.http.post(`${AppConstants.API_ENDPOINT1}${AppConstants.API.SALES_AND_VOLUME_APIS.DOSAGE_DROPDOWN}`, data).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  getNatureDropdown(data) {
    return this.http.post(`${AppConstants.API_ENDPOINT1}${AppConstants.API.SALES_AND_VOLUME_APIS.NATURE_DROPDOWN}`, data).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  getStrengthDropdown(data) {
    return this.http.post(`${AppConstants.API_ENDPOINT1}${AppConstants.API.SALES_AND_VOLUME_APIS.STRENGTH_DROPDOWN}`, data).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  getNDAdropdown(data) {
    return this.http.post(`${AppConstants.API_ENDPOINT1}${AppConstants.API.SALES_AND_VOLUME_APIS.NDA_DROPDOWN}`, data).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  getUpdateSalesVolume(data) {
    return this.http.post(`${AppConstants.API_ENDPOINT1}${AppConstants.API.SALES_AND_VOLUME_APIS.UPDATE_SALES_VOLUME}`, data).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  // getOtherDropdownValues(gen_name, data): Observable<any[]> {
  //   let paramsInput = new HttpParams();
  //   paramsInput = paramsInput.append('gen_name', gen_name);
  //   return this.http.post<any[]>(`${AppConstants.API_ENDPOINT1}${AppConstants.API.SALES_AND_VOLUME_APIS.OTHER_DROPDOWNS}`, data, {params: paramsInput });
  // }

  getSalesAndVolumeData(data): Observable<any[]> {
    return this.http.post<any[]>(`${AppConstants.API_ENDPOINT1}${AppConstants.API.SALES_AND_VOLUME_APIS.SALES_VOLUME_DATA}`, data).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  updateSalesAndVolumeData(data): Observable<any[]> {
    return this.http.post<any[]>(`${AppConstants.API_ENDPOINT1}${AppConstants.API.SALES_AND_VOLUME_APIS.UPDATED_SALES_DATA}`, data).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  pddGenericNames(data): Observable<any[]> {
    return this.http.post<any[]>(`${AppConstants.API_ENDPOINT1}${AppConstants.API.PER_DAY_DOSAGE.GENERIC_NAMES}`, data).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  pddBrandNames(data): Observable<any[]> {
    return this.http.post<any[]>(`${AppConstants.API_ENDPOINT1}${AppConstants.API.PER_DAY_DOSAGE.BRAND_NAMES}`, data).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  pddNDAnumber(data): Observable<any[]> {
    return this.http.post<any[]>(`${AppConstants.API_ENDPOINT1}${AppConstants.API.PER_DAY_DOSAGE.NDA}`, data).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  pddSubmit(data): Observable<any[]> {
    return this.http.post<any[]>(`${AppConstants.API_ENDPOINT1}${AppConstants.API.PER_DAY_DOSAGE.SUBMIT_PDD}`, data).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }
  uploadPDF(data): Observable<any[]> {
    return this.http.post<any[]>(`${AppConstants.API_ENDPOINT1}${AppConstants.API.UPLOADPDF}`, data).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }
}
